export async function loadVerifiedProfile({ auth, identity, endpoint, fetchImpl = fetch }) {
  const firebaseUser = auth?.currentUser;
  await assertSessionIdentity(auth, identity);
  const token = await firebaseUser.getIdToken();
  if (auth.currentUser !== firebaseUser) throw new Error('Your sign-in has changed.');
  const response = await fetchImpl(endpoint, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: '{}',
    cache: 'no-store',
  });
  if (!response.ok) throw new Error('Unable to load your verified account.');
  const { profile } = await response.json();
  if (auth.currentUser !== firebaseUser || !profile
      || ['id', 'tenantId', 'role', 'authUid', 'email'].some(key => profile[key] !== identity[key])) {
    throw new Error('Your account has changed. Please sign in again.');
  }
  return profile;
}

export async function assertSessionIdentity(auth, user) {
  const firebaseUser = auth?.currentUser;
  if (!firebaseUser || firebaseUser.isAnonymous || !user?.id || user.authUid !== firebaseUser.uid) {
    throw new Error('Verified sign-in required.');
  }
  const { claims } = await firebaseUser.getIdTokenResult(false);
  if (auth.currentUser !== firebaseUser || claims.userId !== user.id
      || claims.tenantId !== user.tenantId || claims.role !== user.role
      || claims.email_verified !== true
      || claims.email?.toLowerCase() !== user.email?.toLowerCase()) {
    throw new Error('Your sign-in has changed. Please sign in again.');
  }
}

export async function restoreVerifiedSession({ auth, verifyIdentity, loadProfile }) {
  const firebaseUser = auth?.currentUser;
  if (!firebaseUser || firebaseUser.isAnonymous) return null;
  const identity = await verifyIdentity(firebaseUser.uid);
  if (!identity || auth.currentUser !== firebaseUser) throw new Error('Unable to verify your account.');
  await assertSessionIdentity(auth, identity);
  const profile = await loadProfile(identity);
  if (!profile || profile.id !== identity.id || auth.currentUser !== firebaseUser) {
    throw new Error('Your application account could not be restored.');
  }
  const { password, ...safeProfile } = profile;
  return { ...safeProfile, ...identity };
}
